import { useCurrentSite } from '@hotjar/site';
import type { Feature, SiteWithAccountOrg } from '../utils';
import { isAllowedWithoutGates } from '../utils';

/**
 * Looks for a given feature flag on either the current site, organization, or
 * account. Passing in an optional site will use that site rather than the
 * currently active site.
 *
 * Usage:
 * const hasNewNav = useFeatureFlag('new_navigation');
 *
 * @param feature Name of the feature flag to lookup.
 * @param [site] An optional site object to look for the feature in.
 */
export function useFeatureFlag(feature: Feature, site?: SiteWithAccountOrg): boolean {
  const { data: currentSite } = useCurrentSite();

  const siteNormalized = site ?? currentSite ?? null;

  if (siteNormalized === null) {
    return false;
  }

  return isAllowedWithoutGates(feature, siteNormalized);
}
